<template>
  <div>
    <div id="modal-purchase" class="modal-purchase modal-purchase-hide">
      <div class="container container-purchase">
        <div class="header-purchase">
          <div class="text">{{lastPurchase ? text.btnPurchase2 : text.btnPurchase}}</div>
          <div class="box-close" @click="closePurchaseModal">
            <i class="fas fa-times close-modal"></i>
          </div>
        </div>
        <div class="paging">
          <div
            :class="`paging-page ${pageOpen[1]?'o':'x'} ${pageNo == 1 ? 'active':''}`"
            @click="()=>{pageLR ='r'; pageNo = 1;}"
          >การสั่งซื้อ</div>
          <div
            :class="`paging-page ${pageOpen[2]?'o':'x'} ${pageNo == 2 ? 'active':''}`"
            @click="()=>{pageNo >= 3 ? pageLR = 'l':pageLR ='r'; pageNo = 2;}"
          >สถานที่จัดส่ง</div>
          <div
            :class="`paging-page ${pageOpen[3]?'o':'x'} ${pageNo == 3 ? 'active':''}`"
            @click="()=>{pageNo >= 4 ? pageLR = 'l':pageLR ='r';; pageNo = 3;}"
          >การชำระเงิน</div>
          <div
            :class="`paging-page ${pageOpen[4]?'o':'x'} ${pageNo == 4 ? 'active':''}`"
            @click="()=>{pageLR = 'l'; pageNo = 4;}"
          >การสั่งซื้อสำเร็จ</div>
        </div>

        <div class="panel">
          <div :class="`t t1 ${pageNo == 1 ? 'active' :'non-active'}`">
            <div class="row">
              <div class="col col-md-8" v-if="purchasingProduct">
                <div v-for="(product , index) in purchasingProduct" :key="index">
                  <div class="box-list-product row" v-if="product">
                    <div class="box-image col-12 col-sm-2">
                      <img :src="product.image"  width="100%"/>
                    </div>
                    <div class="box-text col-6 col-sm-4">
                      <div class="head">{{product.name}}</div>
                      <div class="type">Horganice</div>
                      <!-- <div class="promotion">
                        <small v-if="product.delivery && product.delivery > 0" style="padding-left:5px">ค่าส่ง {{ product.delivery }} บาท</small>
                        <small v-else style="padding-left:5px">ค่าจัดส่งฟรี <img src="../assets/icon/sendfree.png" alt="promo" width="30px"/></small>
                      </div> -->
                    </div>
                    <div class="box-price col-6 col-sm-3">
                      <div
                        class="span-price"
                        v-if="product.fullPrice && product.fullPrice > product.price"
                      >
                        จากราคา
                        <span>{{product.fullPrice | currency}}</span>
                      </div>
                      <div class="text-price">฿ {{product.price | currency}}</div>
                      <div class="span-vat" v-if="product.isIncludeVat">(รวมภาษีแล้ว)</div>
                    </div>
                    <div class="box-number col-12 col-sm-3">
                      <i
                        :class="`fas fa-minus ${product.number <= 1 ? 'none':''}`"
                        @click="numberPluse('-',index)"
                      ></i>
                      <input
                        type="number"
                        name="number-order"
                        id="number-order"
                        v-model.number="product.number"
                        placeholder="จำนวน"
                        min="1"
                        max="999"
                        @keyup="changeNumber()"
                        @input="changeNumber()"
                      />
                      <i
                        :class="`fas fa-plus ${product.number >= product.balanceProduct ? 'none':''}`"
                        @click="numberPluse('+',index)"
                      ></i>
                      <div>

                      </div>
                      <!-- <i class="far fa-trash-alt"></i>
                      <a @click="removeItem(index)" href="#" class="remove-item">ลบ</a> -->
                      <i class="far fa-trash-alt" @click="removeItem(index)" style="margin-top:10px;color: red;background-color: white;"></i>
                    </div>
                  </div>

                </div>
                <div class="text-center" v-if="!fromBuyNow">
                  <button class="btn-home" @click.prevent="goToHomePage()">เลือกสินค้าเพิ่ม</button>
                </div>
              </div>

              <div class="col col-md-4">
                <div class="box-border">
                  <div class="box-conclusion">
                    <div class="head">รหัสโปรโมชั่น (ถ้ามี)</div>
                    <div class="row">
                      <div class="col col-8 row-bottom " style="padding: 15px 5px 0 5px; margin:0">
                        <div class="box-form-in">
                          <input type="text" name="promocode" style="font-size: 15px" v-model="inputPromoCode" :style="`${(promoCode && promoCode.get('countLimit') < promoCode.get('limit')) ? 'pointer-events: none;' : ''}`" placeholder="โค้ดส่วนลด"/>
                        </div>
                      </div>
                      <div class="col col-4" style="padding: 15px 0 0 0">
                        <button class="btn-check-promocode" @click="removePromocode()" v-if="promoCode && promoCode.get('countLimit') < promoCode.get('limit')">ยกเลิก</button>
                        <button class="btn-check-promocode" @click="checkPromocode()" v-else>ตรวจสอบ</button>
                      </div>
                      <div style="margin-top:-10px;padding-left:8px;">
                        <small v-if="promoCode && promoCode.get('countLimit') < promoCode.get('limit')" class="text-success"><i class="far fa-check-circle"></i> {{promoCode.get('description')}}</small>
                        <small v-else-if="promoCode && promoCode.get('countLimit') >= promoCode.get('limit')" class="text-danger"><i class="far fa-times-circle"></i> โค้ดนี้ถูกใช้ไปแล้ว</small>
                        <small v-else-if="isInvalidPromoCode" class="text-danger"><i class="far fa-times-circle"></i> รหัสโปรโมชั่นไม่ถูกต้องกรุณาลองใหม่อีกครั้ง</small>
                      </div>
                    </div>
                  </div>

                  <div class="box-conclusion">
                    <div class="head">สรุปรายการสั่งซื้อ</div>
                    <table>
                      <tr>
                        <th>ราคา (จำนวน {{formPurchase.number}} ชิ้น)</th>
                        <td>฿{{formPurchase.total.fullPrice | currency}}</td>
                      </tr>
                      <tr class="text-danger">
                        <th>ส่วนลดสินค้า</th>
                        <td>฿{{formPurchase.total.discount * -1 | currency}}</td>
                      </tr>
                      <tr>
                        <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                        <td>฿{{formPurchase.total.beforeVat | currency}}</td>
                      </tr>
                      <tr>
                        <th>ภาษี {{formPurchase.vatPer}}%</th>
                        <td>฿{{formPurchase.total.vatBath | currency}}</td>
                      </tr>
                      <tr>
                        <th>ค่าจัดส่ง</th>
                        <td>฿{{formPurchase.total.deliveryBath | currency}}</td>
                      </tr>
                      <tr class="text-danger">
                        <th>ส่วนลดโปรโมชั่น</th>
                        <td>฿{{formPurchase.total.promoDiscout | currency}}</td>
                      </tr>
                      <tr>
                        <th class="sum">ราคาสุทธิ</th>
                        <td class="sum">฿{{formPurchase.total.cost | currency}}</td>
                      </tr>
                    </table>
                    <div
                      @click.prevent="submitPurchaseOrder1()"
                      :class="`btn-purchase-order ${formPurchase.number < 1 ? 'non-active':''}`"
                    >ดำเนินการที่อยู่จัดส่ง</div>
                    <div class="text-require" v-html="checkFormPurchase"></div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
          <div :class="`t ${pageLR == 'r' ? 't2R' : 't2L'} ${pageNo == 2 ? 'active' :'non-active'}`">
            <div style="padding:15px">
              <div class="box-border" style="padding:15px">
                <div class="row row-bottom">
                  <div class="head" style="font-size:25px; margin: 0 auto 15px auto">เลือกที่อยู่สำหรับจัดส่ง</div>
                </div>
                <span class="address-selector">

                  <span v-if="user">
                    <div class="box-border text-left row" :class="`${indexAddress == 1 ? 'active' : ''}`" @click="changeAddress(1 , user , null)">
                      <div style="width:50px;" class="text-center">
                        <div class="circle-out">
                          <div class="circle-in" v-if="indexAddress == 1"></div>  
                        </div>
                      </div>
                      <div>
                        <p class="topic-address">ที่อยู่ผู้ใช้ </p>
                        <p class="detail-address">{{user.get('userProfile').get('address')}} {{user.get('userProfile').get('addressZipcode')}}</p>
                      </div>
                    </div>
                  
                    <span v-for="(owner , index) of owners" :key="index">
                      <div class="box-border text-left row" :class="`${indexAddress == index + 2 ? 'active' : ''}`" v-if="owner.get('apartment') && owner.get('apartment').get('address')" @click="changeAddress(index + 2 , user , owner)">
                        <div style="width:50px;" class="text-center">
                          <div class="circle-out">
                            <div class="circle-in" v-if="indexAddress == index + 2"></div>  
                          </div>
                        </div>
                        <div>
                          <p class="topic-address">ที่อยู่ที่หอพัก {{owner.get('apartment').get('name')}}</p>
                          <p class="detail-address">{{owner.get('apartment').get('address') ? owner.get('apartment').get('address') : '-'}} {{owner.get('apartment').get('addressZipcode')}}</p>
                        </div>
                      </div>
                    </span>
                  </span>
                  
                  <span>
                    <div class="box-border text-left row" :class="`${indexAddress == 0 ? 'active' : ''}`" @click="changeAddress(0 , user)">
                      <div style="width:50px;" class="text-center">
                        <div class="circle-out">
                          <div class="circle-in"  v-if="indexAddress == 0"></div>  
                        </div>
                      </div>
                      <div>
                        <p class="topic-address" style="margin-top: 8px;">ที่อยู่อื่นๆ </p>
                      </div>
                    </div>
                  </span>
                </span>
                
                
                <div class="box-border" style="padding-bottom:15px">
                  <div class="row row-bottom">
                    <div class="col-md-12">
                      <div class="head">ที่อยู่สำหรับจัดส่ง</div>
                    </div>
                    <div class="col col-md-6">
                      <div class="box-form-in">
                        <label for="who-purchase">
                          ชื่อผู้สั่งซื้อ
                          <span class="required">*</span>
                        </label>
                        <input
                          type="text"
                          id="who-purchase"
                          name="who-purchase"
                          required
                          v-model="formPurchase.userName"
                          placeholder="ชื่อผู้สั่งซื้อ"
                        />
                      </div>
                      <div class="box-form-in">
                        <label for="tel-purchase">
                          เบอร์โทรติดต่อ ( ผู้สั่งซื้อ )
                          <span class="required">*</span>
                        </label>
                        <input
                          type="tel"
                          name="tel-purchase"
                          id="tel-purchase"
                          required
                          v-model="formPurchase.userTel"
                          placeholder="เบอร์โทรติดต่อ ( ผู้สั่งซื้อ )"
                        />
                      </div>
                      <div class="box-form-in">
                        <label for="tel-purchase-2">เบอร์โทรติดต่อ ( สำรอง )</label>
                        <input
                          type="tel"
                          name="tel-purchase-2"
                          id="tel-purchase-2"
                          v-model="formPurchase.apartmentTel"
                          placeholder="เบอร์โทรติดต่อ ( ตึก )"
                        />
                      </div>
                    </div>
                    <div class="col col-md-6">
                      <div class="box-form-in">
                        <label for="name-purchase">
                          ชื่อหอพัก (ถ้ามี)
                        </label>
                        <input
                          type="text"
                          id="name-purchase"
                          name="name-purchase"
                          required
                          v-model="formPurchase.apartmentName"
                          placeholder="ชื่อหอพัก"
                        />
                      </div>
                      <div class="box-form-in">
                        <label for="address-purchase">
                          ที่อยู่จัดส่ง
                          <span class="required">*</span>
                        </label>
                        <textarea
                          class="note"
                          name="address-purchase"
                          id="address-purchase"
                          v-model="formPurchase.apartmentAddress"
                          placeholder="ที่อยู่จัดส่ง"
                        ></textarea>
                      </div>
                      <div class="box-form-in">
                        <label for="note-purchase">หมายเหตุ</label>
                        <textarea
                          class="note"
                          name="note-purchase"
                          id="note-purchase"
                          v-model="formPurchase.note"
                          placeholder="หมายเหตุ"
                        ></textarea>
                      </div>
                      <div class="note-star">
                        <span class="star">*</span>หมายถึง จำเป็นต้องใส่ข้อมูล
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            

            <div class="row">
              <div class="col col-md-8">
                <div class="box-list-product row" v-for="(product , index) in purchasingProduct" :key="index">
                  <div class="box-image col-12 col-sm-2">
                    <img :src="product.image"  width="100%"/>
                  </div>
                  <div class="box-text col-6 col-sm-4">
                    <div class="head">{{product.name}}</div>
                    <div class="type">Horganice</div>
                    <div class="promotion">
                      <small v-if="product.deliveryBath && product.deliveryBath > 0" style="padding-left:5px">ค่าส่ง {{ product.deliveryBath }} บาท</small>
                      <small v-else style="padding-left:5px">ค่าจัดส่งฟรี <img src="../assets/icon/sendfree.png" alt="promo" width="30px"/></small>
                    </div>
                  </div>
                  <div class="box-price col-6 col-sm-3">
                    <div
                      class="span-price"
                      v-if="product.fullPrice && product.fullPrice > product.price"
                    >
                      จากราคา
                      <span>{{product.fullPrice | currency}}</span>
                    </div>
                    <div class="text-price">฿ {{product.price | currency }}</div>
                    <div class="span-vat" v-if="product.isIncludeVat">(รวมภาษีแล้ว)</div>
                  </div>
                  <div class="box-number box-number col-12 col-sm-3">จำนวน : {{product.number}}</div>
                </div>
              </div>

              <div class="col col-md-4">
                <div class="box-border">
                  <div class="box-conclusion">
                    <div class="head">รหัสโปรโมชั่น (ถ้ามี)</div>
                    <div class="row">
                      <div class="col col-8 row-bottom " style="padding: 15px 5px 0 5px; margin:0">
                        <div class="box-form-in">
                          <input type="text" name="promocode" style="font-size: 15px" v-model="inputPromoCode" :style="`${(promoCode && promoCode.get('countLimit') < promoCode.get('limit')) ? 'pointer-events: none;' : ''}`" placeholder="โค้ดส่วนลด"/>
                        </div>
                      </div>
                      <div class="col col-4" style="padding: 15px 0 0 0">
                        <button class="btn-check-promocode" @click="removePromocode()" v-if="promoCode && promoCode.get('countLimit') < promoCode.get('limit')">ยกเลิก</button>
                        <button class="btn-check-promocode" @click="checkPromocode()" v-else>ตรวจสอบ</button>
                      </div>
                      <div style="margin-top:-10px;padding-left:8px;">
                        <small v-if="promoCode && promoCode.get('countLimit') < promoCode.get('limit')" class="text-success"><i class="far fa-check-circle"></i> {{promoCode.get('description')}}</small>
                        <small v-else-if="promoCode && promoCode.get('countLimit') >= promoCode.get('limit')" class="text-danger"><i class="far fa-times-circle"></i> โค้ดนี้ถูกใช้ไปแล้ว</small>
                        <small v-else-if="isInvalidPromoCode" class="text-danger"><i class="far fa-times-circle"></i> รหัสโปรโมชั่นไม่ถูกต้องกรุณาลองใหม่อีกครั้ง</small>
                      </div>
                    </div>
                  </div>

                  <div class="box-conclusion">
                    <div class="head">สรุปรายการสั่งซื้อ</div>
                    <table>
                      <tr>
                        <th>ราคา (จำนวน {{formPurchase.number}} ชิ้น)</th>
                        <td>฿{{formPurchase.total.fullPrice | currency}}</td>
                      </tr>
                      <tr class="text-danger">
                        <th>ส่วนลดสินค้า</th>
                        <td>฿{{formPurchase.total.discount * -1 | currency}}</td>
                      </tr>
                      <tr>
                        <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                        <td>฿{{formPurchase.total.beforeVat | currency}}</td>
                      </tr>
                      <tr>
                        <th>ภาษี {{formPurchase.vatPer}}%</th>
                        <td>฿{{formPurchase.total.vatBath | currency}}</td>
                      </tr>
                      <tr>
                        <th>ค่าจัดส่ง</th>
                        <td>฿{{formPurchase.total.deliveryBath | currency}}</td>
                      </tr>
                      <tr class="text-danger">
                        <th>ส่วนลดโปรโมชั่น</th>
                        <td>฿{{formPurchase.total.promoDiscout | currency}}</td>
                      </tr>
                      <tr>
                        <th class="sum">ราคาสุทธิ</th>
                        <td class="sum">฿{{formPurchase.total.cost | currency}}</td>
                      </tr>
                    </table>
                    <div
                      @click.prevent="submitPurchaseOrder2()"
                      :class="`btn-purchase-order ${!checkAddress ? 'non-active':''}`"
                    >ดำเนินการชำระเงิน</div>

                    <p style="padding-left:10px;color:#858585">(สินค้าจัดส่งตามรอบที่บริษัทฯ กำหนด)</p>
                    <div class="text-require" v-html="checkFormAddress"></div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          <div :class="`t ${pageLR == 'r' ? 't3R' : 't3L'} t3 ${pageNo == 3 ? 'active' :'non-active'}`">
            <div style="padding:15px">
              <div class="box-border">
                <div class="row row-bottom">
                  <div class="col-md-12" style="padding-top:0">
                    <div class="head" >กรุณากรอกข้อมูลในการออกใบกำกับภาษี</div>
                  </div>
                  <div class="col col-md-12">
                    <div class="box-form-in row">
                      <div class="col-md-4 col-xl-3 same-data">
                        <p for="same-address" >ชื่อเดียวกับข้อมูลจัดส่ง</p>
                        <input
                          type="checkbox"
                          name="same-address"
                          id="same-address"
                          style="width:30px;"
                          v-model="formPurchase.isSameName"
                          @change="changeSame"
                        />
                      </div>
                      <div class="col-md-8 col-xl-9">
                        <div class="box-input">
                          <label for="who-purchase-tax">
                            ชื่อผู้สั่งซื้อ/ชื่อบริษัท
                            <span class="required">*</span>
                          </label>
                          <input
                            type="text"
                            id="who-purchase-tax"
                            name="who-purchase-tax"
                            required
                            v-model="formPurchase.userNameTax"
                            placeholder="ชื่อผู้สั่งซื้อ/ชื่อบริษัท"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="box-form-in row">
                      <div class="col-md-4 col-xl-3"></div>
                      <div class="col-md-8 col-xl-9">
                        <div class="box-input">
                          <label for="tax-id">
                            เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี
                            <span class="required">*</span>
                          </label>
                          <input
                            type="text"
                            id="tax-id"
                            name="tax-id"
                            required
                            v-model="formPurchase.taxId"
                            placeholder="Tax ID"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="box-form-in row">
                      <div class="col-md-4 col-xl-3 same-data">
                        <p for="same-address">ที่อยู่เดียวกับที่อยู่จัดส่ง</p>
                        <input
                          type="checkbox"
                          name="same-address"
                          id="same-address"
                          v-model="formPurchase.isSameAddress"
                          @change="changeSame"
                        />
                      </div>
                      <div class="col-md-8 col-xl-9">
                        <div class="box-input">
                          <label for="address-purchase-tax">
                            ที่อยู่ในการออกใบกำกับภาษี
                            <span class="required">*</span>
                          </label>
                          <textarea
                            name="address-purchase-tax"
                            id="address-purchase-tax"
                            v-model="formPurchase.apartmentAddressTax"
                            placeholder="Address"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="note-star">
                      <span class="star">*</span>หมายถึง จำเป็นต้องใส่ข้อมูล
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div style="padding: 15px">
              <div class="box-border" style="padding-bottom: 15px;">
                <div class="row row-bottom">
                  <div class="col col-md-12">
                    <div class="head" style="font-size: 25px;margin-bottom:20px;">ช่องทางการชำระเงิน</div>
                    <div class="box-list-bank row box-border" v-if="banks">
                      <div class="image-bank bb col-sm-3">
                        <img :src="getImage" alt="KBANK" />
                      </div>
                      <div class="text-bank col-sm-5">
                        <div class="account-name">{{banks[0].bankAccount}}</div>
                        <div class="account-no">{{banks[0].bankAccountNo}}</div>
                        <div class="bank-name">{{banks[0].bankName}}</div>
                      </div>
                      <div class="cost col-sm-4">
                        <div class="text">ยอดโอน</div>
                        <div class="number">฿ {{formPurchase.total.cost | currency}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row row-bottom">
                  <div class="col col-md-12">
                    <div class="head">แนบหลักฐานการโอน</div>
                  </div>
                  <div class="col col-md-12">
                    <div class="box-image">
                      <div class="box-image-proof">
                        <img
                          v-if="formPurchase && formPurchase.proofOfPayment"
                          :src="`data:image/*;base64,${formPurchase.proofOfPayment._data}`"
                          alt
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col col-md-12">
                    <div class="box-proof">
                      <label
                        :class="`btn ${isSavingImageProof ? 'not-active' :''}`"
                        for="proof-of-payment"
                        style="margin: 0;"
                      >
                        {{formPurchase.proofOfPayment ? 'เปลี่ยนรูปหลักฐาน':'แนบรูปหลักฐาน'}}
                        <i
                          class="fas fa-upload loadding-spinner m"
                          v-show="!isSavingImageProof && !formPurchase.proofOfPayment"
                        ></i>
                        <i class="fa fa-spinner fa-spin loadding-spinner m" v-show="isSavingImageProof"></i>
                        <i
                          class="far fa-check-circle loaded-checked l"
                          v-show="formPurchase.proofOfPayment && !isSavingImageProof"
                        ></i>
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        tabindex="-1"
                        id="proof-of-payment"
                        @change="processImageProof"
                        style="display:none;"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-12">
                <div class="box-conclusion box-border">
                  <div class="head">ที่อยู่ในการจัดส่ง</div>
                  <table class="address">
                    <tr>
                      <th>
                        <i class="fas fa-map-marker-alt"></i>
                        {{formPurchase.userName}}
                      </th>
                    </tr>
                    <tr>
                      <td
                        class="address"
                      >{{`${formPurchase.apartmentName} ${formPurchase.apartmentAddress}`}}</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fas fa-phone-alt"></i>
                        {{formPurchase.userTel}}
                      </td>
                    </tr>
                  </table>
                  <div class="head">สรุปรายการสั่งซื้อ</div>
                  <table>
                    <tr>
                      <th>ราคา (จำนวน {{formPurchase.number}} ชิ้น)</th>
                      <td>฿{{formPurchase.total.fullPrice | currency}}</td>
                    </tr>
                    <tr class="text-danger">
                      <th>ส่วนลดสินค้า</th>
                      <td>฿{{formPurchase.total.discount * -1 | currency}}</td>
                    </tr>
                    <tr>
                      <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                      <td>฿{{formPurchase.total.beforeVat | currency}}</td>
                    </tr>
                    <tr>
                      <th>ภาษี {{formPurchase.vatPer}}%</th>
                      <td>฿{{formPurchase.total.vatBath | currency}}</td>
                    </tr>
                    <tr>
                      <th>ค่าจัดส่ง</th>
                      <td>฿{{formPurchase.total.deliveryBath | currency}}</td>
                    </tr>
                    <tr class="text-danger">
                      <th>ส่วนลดโปรโมชั่น</th>
                      <td>฿{{formPurchase.total.promoDiscout | currency}}</td>
                    </tr>
                    <tr>
                      <th class="sum">ราคาสุทธิ</th>
                      <td class="sum">฿{{formPurchase.total.cost | currency}}</td>
                    </tr>
                  </table>
                  <div
                    @click="requestPurchase()"
                    :class="`btn-purchase-order ${formPurchase.number < 1 || isSavingImageProof || !formPurchase.proofOfPayment ? 'non-active':''}`"
                    style="width:250px;margin:0 auto"
                  >ยืนยันการชำระเงิน</div>
                  <div class="text-require" v-html="checkFormProof"></div>
                </div>
              </div>
            </div>
          </div>

          <div :class="`t t4 ${pageNo == 4 ? 'active' :'non-active'}`">
            <div class="row">
              <div class="col col-md-12">
                <div class="box-success-purchase" v-if="lastPurchase">
                  <div class="icon">
                    <i
                      v-show="lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                      class="fas fa-clipboard-check success"
                    ></i>
                    <i
                      v-show="!lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                      class="fas fa-user-clock wait"
                    ></i>
                    <i v-show="lastPurchase.get('isCancel')" class="fas fa-window-close reject"></i>
                  </div>
                  <div class="head">
                    ระบบได้รับคำสั่งซื้อจากคุณแล้ว ({{!lastPurchase.get('isCancel') ? lastPurchase.get('isConfirm') ? 'คำสั่งซื้อได้รับการยืนยันแล้ว':'รอการตรวจสอบการชำระเงิน':'คำสั่งซื้อถูกยกเลิก'}})
                    <!-- <span
                      class="refresh"
                      @click="getPurchaseOrder()"
                    >
                      <i class="fas fa-redo-alt"></i>(รีเฟรช)
                    </span> -->
                    <span
                      v-if="lastPurchase"
                    >{{dateFormat(lastPurchase.lastQuery,'DD/MM/YY, HH:mm:ss') }}</span>
                  </div>
                  <!-- <div
                    class="detail"
                    v-if="!lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                  >จะมีทีมงานติดต่อกลับเพื่อยืนยันคำสั่งซื้อภายใน 7 วัน</div> -->
                  <!-- <div
                    v-if="!lastPurchase.get('isCancel')"
                    class="detail"
                  >ท่านจะได้รับสินค้า ภายใน 3-5 วันทำการ(ใน กทม. และ ปริมณฑล) 5-7 วันทำการ(ต่างจังหวัด) กรณีคำสั่งซื้อถูกต้อง</div> -->
                  <div
                    v-if="!lastPurchase.get('isCancel')"
                    class="detail"
                  >ท่านจะได้รับสินค้าภายใน 7 วันทำการ หากกรณีคำสั่งซื้อถูกต้อง</div>
                  <div v-else class="detail">คำสั่งซื้อนี้ถูกยกเลิกแล้ว กรุณาตรวจสอบจำนวนสินค้าอีกครั้ง หรือลองใหม่อีกครั้งภายหลัง</div>
                  <div class="last-purchase" v-if="lastPurchase">
                    <div
                      class="head"
                    >รายการคำสั่งซื้อล่าสุด ({{dateFormat(lastPurchase.get('purchaseDate'),'DD/MM/YY, HH:mm:ss')}})</div>
                    <div class="order-list">
                      <table class="table table-bordered" v-if="lastPurchase">
                        <tr>
                          <th>ลำดับ</th>
                          <th>ชื่อสินค้า</th>
                          <th>ราคาต่อชิ้น(บาท)</th>
                          <th>จำนวน(ชิ้น)</th>
                          <th class="text-danger">ส่วนลด(บาท)</th>
                          <th>รวมเป็นเงิน(บาท)</th>
                        </tr>
                        <tr
                          v-show="lastPurchase.get('sets')"
                          v-for="(item, index) in lastPurchase.get('sets')"
                          :key="index"
                        >
                          <td>{{index+1}}</td>
                          <td>{{item.productName}}</td>
                          <td class="number">{{item.pricePer || 0  | currency}}</td>
                          <td class="number">{{item.setNumber ? item.setNumber : item.number | arabic }}</td>
                          <td class="number text-danger">{{(item.setDiscountBath + item.discountBath) * -1 | currency}}</td>
                          <td class="number">{{item.pricePer * (item.setNumber ? item.setNumber : item.number ) - ((item.setDiscountBath + item.discountBath) * -1) | currency}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="5">ราคา</td>
                          <td class="number">{{formPurchase.total.fullPrice | currency}}</td>
                        </tr>
                        <tr class="text-danger">
                          <td class="sum-text" colspan="5">ส่วนลดรวม</td>
                          <td class="number">{{lastPurchase.get('totalDiscount') * -1 | currency}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="5">ยอดรวมก่อนภาษี</td>
                          <td class="number">{{lastPurchase.get('beforeVat') | currency}}</td>
                        </tr>
                        <tr>
                          <td
                            class="sum-text"
                            colspan="5"
                          >ภาษี {{lastPurchase.get('vatPer') | currency}}%</td>
                          <td class="number">{{lastPurchase.get('vatBath') | currency}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="5">ค่าจัดส่ง</td>
                          <td class="number">{{lastPurchase.get('deliveryBath') | currency}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="5">ยอดสุทธิ / ยอดโอน</td>
                          <td class="number sum">{{lastPurchase.get('cost') | currency}}</td>
                        </tr>
                      </table>
                    </div>

                    <div class="box-address">
                      <div class="head">ข้อมูลสำหรับการจัดส่งล่าสุด</div>
                      <div
                        class="detail"
                      >{{`${lastPurchase.get('orderName')} ${lastPurchase.get('apartmentName')} ${lastPurchase.get('orderAddress')} โทร.${lastPurchase.get('orderTel')}`}}</div>
                    </div>
                    <div class="box-address">
                      <div class="head">ข้อมูลสำหรับออกใบกำกับภาษีล่าสุด</div>
                      <div
                        class="detail"
                      >{{`${lastPurchase.get('taxId')} ${lastPurchase.get('orderNameTax')} ${lastPurchase.get('orderAddressTax')}`}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-12">
                <div class="btn-back" @click="closePurchaseModal()">ปิดหน้าต่างนี้</div>
                <!-- <div
                  :class="`btn btn-purchase-back ${product.balanceProduct <=0 ? 'non-active':''}`"
                  @click.prevent="submitPurchaseOrder4(formPurchase)"
                >{{lastPurchase ? text.btnPurchase2 : text.btnPurchase}}</div> -->
              </div>
            </div>
          </div>
          <!-- <div style="width:100%;border:1px solid black" class="border-shadow"> </div> -->
        </div>
      </div>

      <div id="modal-confirm" class="modal-confirm modal-confirm-hide">
        <div class="container container-confirm">
          <div class="header-confirm">
            <div class="text">ยืนยันการสั่งซื้อ</div>
            <div class="box-close" @click="closeConfirmModal()">
              <i class="fas fa-times close-modal"></i>
            </div>
          </div>
          <div class="panel">
            <div class="box-order">
              <div class="head">สรุปรายการสั่งซื้อ ( {{formPurchase.number}} รายการ )</div>
              <div class="order-list">
                <table class="table table-bordered">
                  <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อสินค้า</th>
                    <th>ราคาต่อชิ้น(บาท)</th>
                    <th>จำนวน(ชิ้น)</th>
                    <th class="text-danger">ส่วนลด(บาท)</th>
                    <th>รวมเป็นเงิน(บาท)</th>
                  </tr>
                  <tr v-for="(product , index) in purchasingProduct" :key="index">
                    <td>{{ index + 1}}</td>
                    <td>{{ product.name }}</td>
                    <td class="number">{{product.fullPrice | currency }}</td>
                    <td class="number">{{product.number | arabic}}</td>
                    <td class="number text-danger">{{product.discount.total * -1 | currency }}</td>
                    <td class="number">{{product.fullPrice * product.number + product.discount.total | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="5">ราคา</td>
                    <td class="number">{{formPurchase.total.fullPrice | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text text-danger" colspan="5">ส่วนลด</td>
                    <td class="number text-danger">฿{{formPurchase.total.discount * -1 | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="5">ยอดรวมก่อนภาษี</td>
                    <td class="number">{{formPurchase.total.beforeVat | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="5">ภาษี {{formPurchase.vatPer | currency}}%</td>
                    <td class="number">{{formPurchase.total.vatBath | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="5">ค่าจัดส่ง</td>
                    <td class="number">{{formPurchase.total.deliveryBath | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text text-danger" colspan="5">ส่วนลดโปรโมชั่น</td>
                    <td class="number text-danger">฿{{formPurchase.total.promoDiscout  | currency}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="5">ยอดสุทธิ / ยอดโอน</td>
                    <td class="number sum">{{formPurchase.total.cost | currency}}</td>
                  </tr>
                </table>
              </div>
              <div class="box-address">
                <div class="head">ข้อมูลสำหรับการจัดส่ง</div>
                <div class="detail">
                  {{`${formPurchase.userName} ${formPurchase.apartmentName} ${formPurchase.apartmentAddress} โทร.${formPurchase.userTel}`}}
                </div>
              </div>
              <div class="box-address">
                <div class="head">ข้อมูลสำหรับออกใบกำกับภาษี</div>
                <div class="detail">
                  {{`${formPurchase.taxId} ${formPurchase.userNameTax} ${formPurchase.apartmentAddressTax}`}}</div>
              </div>
            </div>

            <div class="box-confirm">
              <div class="text">โปรดตรวจสอบความถูกต้อง หากคุณยืนยันในหน้านี้แล้วคุณจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก
              </div>
              <div class="confirm">
                <div class="btn-back" @click="closeConfirmModal()" v-show="!isSavingPurchaseOrder">กลับไปแก้ไขข้อมูล
                </div>
                <div @click.prevent="submitPurchaseOrder3()" v-show="!isSavingPurchaseOrder"
                  :class="`btn-purchase-order ${formPurchase.number < 1 || isSavingImageProof || !formPurchase.proofOfPayment || isSavingPurchaseOrder ? 'non-active':''}`">
                  ยืนยันการชำระเงิน</div>
                <loading-cycle v-show="isSavingPurchaseOrder" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import store from '../store';
const text = {
  btnPurchase: "สั่งซื้อสินค้าตอนนี้",
  btnPurchase2: "สั่งซื้อสินค้าเพิ่มเติม",
  btnRegister: "การใช้งานเครื่องอ่านบัตร",
  btnRegister2: "เปิดใช้งานเครื่องอ่านบัตร",
  successRegister: "เปิดใช้งานเครื่องอ่านบัตรสำเร็จ!!",
  failRegister: "เปิดใช้งานเครื่องอ่านบัตรไม่สำเร็จ!!"
};
export default {
  props:['isOnlyOne'],
  data() {
    return {
      text,
      pageOpen: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      pageNo:1,
      pageLR: "r",
      formPurchase: {
        userId: null,
        userName: "",
        taxId: "",
        userNameTax: "",
        userTel: "",
        apartmentId: "",
        apartmentName: "",
        apartmentAddress: "",
        apartmentAddressTax: "",
        apartmentTel: "",
        productId: "",
        productName: "",
        proofOfPayment: null,
        datePurchaseOrder: null,
        number:0,
        vatPer:7,
        note: "",
        isSameAddress: false,
        isSameName: false,
        total: {},
        promoCode:""
      },
      inputPromoCode: "",
      promoCode:"",
      indexAddress: 0,
      banks: [
        {
          no: "",
          bankName: "",
          bankAccount: "",
          bankAccountNo: ""
        }
      ],
      isSavingImageProof:false,
      isSavingPurchaseOrder:false,
      lastPurchase: "",
      isInvalidPromoCode: false
    }
  },
  methods: {
    closePurchaseModal() {
      $("#main-cid-detail").removeClass("modal-open");
      $("#modal-purchase").addClass("modal-purchase-hide");
      $("body").css({"overflow-y":"scroll"})

      if(this.carts && this.carts.length > 0){
        $("#cart-bar").removeClass("hide-cart");
        $("#cart-bar").addClass("show-cart");
      }

      if(!this.fromBuyNow){
        this.pageOpen={
          1: true,
          2: false,
          3: false,
          4: false
        }
        this.pageNo = 1
      }
      this.removePromocode()
      this.changeNumber()
      if(this.lastPurchase) location.reload() // reload balanceProduct
    },
    numberPluse(data,index) {
      if (data == "+") {
        if(this.purchasingProduct[index].number < this.purchasingProduct[index].balanceProduct) this.purchasingProduct[index].number += 1
      } else if (data == "-") {
        if(this.purchasingProduct[index].number > 1) this.purchasingProduct[index].number -= 1
      }
      this.changeNumber()
    },
    changeNumber: function() {
      this.formPurchase.number = 0
      this.formPurchase.total =  {
        cost : 0,
        beforeVat : 0,
        vatBath : 0,
        deliveryBath: 0,
        discount:0,
        fullPrice:0,
        promoDiscout:0
      }
      let delivered = []
      for(let product of this.purchasingProduct){

        let DISCOUNT_BATH = 0

        this.formPurchase.number += product.number

        if (product.isIncludeVat) {
          product.cost = (product.price * product.number);
          product.beforeVat = (product.cost * 100) / (100 + 7);
          product.vatBath = product.cost - product.beforeVat;
        } else {
          product.beforeVat = product.price * product.number;
          product.vatBath = (product.beforeVat *  7) / 100;
          product.cost = (product.beforeVat + product.vatBath)
        }

        if(product.fullPrice - product.price > 0)
          DISCOUNT_BATH = (product.price - product.fullPrice) * product.number
        if(product.discount && product.discount.discountBath &&  product.number >= product.discount.number){
          if(product.discount.type == 'static_mass') // discount mass.
            DISCOUNT_BATH -= Math.floor(product.number / product.discount.number) * product.discount.discountBath
          else // discount only 1 per purchase.
            DISCOUNT_BATH -= product.discount.discountBath
        }

        if(!delivered.includes(product.deliveryCategory) && product.delivery > 0){
          delivered.push(product.deliveryCategory)
          product.deliveryBath = product.delivery
        }else{
          product.deliveryBath = product.deliveryPerNumber
        }

        product.deliveryBath += product.deliveryPerNumber * (product.number - 1)
        product.discount.total = DISCOUNT_BATH
        product.cost = (product.fullPrice * product.number) + product.discount.total + product.deliveryBath
        
        this.formPurchase.total.fullPrice += product.fullPrice * product.number
        this.formPurchase.total.beforeVat += product.beforeVat
        this.formPurchase.total.vatBath += product.vatBath
        this.formPurchase.total.deliveryBath += product.deliveryBath
        this.formPurchase.total.discount += product.discount.total
        this.formPurchase.total.cost += product.cost
        
      }
      if(this.promoCode && this.promoCode.get('countLimit') < this.promoCode.get('limit') && this.formPurchase.total.cost > this.promoCode.get('minPrice')){
        this.formPurchase.promoCode = this.promoCode
        if(this.promoCode.get('discountPercent')){
          this.formPurchase.total.promoDiscout = (this.promoCode.get('discountPercent') / 100) * this.formPurchase.total.cost
          // this.formPurchase.total.discount -= (this.promoCode.get('discountPercent') / 100) * this.formPurchase.total.cost
          this.formPurchase.total.cost -= (this.promoCode.get('discountPercent') / 100) * this.formPurchase.total.cost
        }else if(this.promoCode.get('discountBath')){
          this.formPurchase.total.promoDiscout = this.promoCode.get('discountBath')
          // this.formPurchase.total.discount -= this.promoCode.get('discountBath')
          this.formPurchase.total.cost -= this.promoCode.get('discountBath')
        }
      }
      console.log(this.formPurchase.promoDiscout)
    },
    changeAddress(index , user , owner){
      this.indexAddress = index
      if(owner && user && index != 0){
        this.formPurchase.userId = user.id
        this.formPurchase.userName = `${user.get('userProfile').get('firstName')} ${user.get('userProfile').get('lastName')}`
        this.formPurchase.apartmentId = owner.get('apartment').id
        this.formPurchase.apartmentName = owner.get('apartment').get('name')
        this.formPurchase.apartmentAddress = `${owner.get('apartment').get('address')} ${owner.get('apartment').get('addressZipcode')}`
        this.formPurchase.userTel = user.get('tel')
        this.formPurchase.apartmentTel = owner.get('apartment').get('tel')[0]
      }else if(user && index != 0){
        this.formPurchase.userId = user.id
        this.formPurchase.userName = `${user.get('userProfile').get('firstName')} ${user.get('userProfile').get('lastName')}`
        this.formPurchase.apartmentId = ""
        this.formPurchase.apartmentName = ""
        if(user.get('userProfile').get('address') && user.get('userProfile').get('addressZipcode')){
          this.formPurchase.apartmentAddress = `${user.get('userProfile').get('address')} ${user.get('userProfile').get('addressZipcode')}`
        }else{
          this.formPurchase.apartmentAddress = ""
        }
        if(user.get('tel')){
          this.formPurchase.userTel = user.get('tel')
        }else{
          this.formPurchase.userTel = ""
        }
        this.formPurchase.apartmentTel = ""
      }else{
        this.formPurchase.userId = user.id
        this.formPurchase.userName = ""
        this.formPurchase.apartmentId = ""
        this.formPurchase.apartmentName = ""
        this.formPurchase.apartmentAddress = ""
        this.formPurchase.userTel = ""
        this.formPurchase.apartmentTel = ""
      }
    },
    submitPurchaseOrder1() {
      let addressType = this.indexAddress == 0 ? 'other' : this.indexAddress == 1 ? 'user' : 'apartment'
      if(this.user) this.$mixpanel.track(`click-purchase-stap2`, {products: this.purchasingProduct.map(p=>{return p.id}) , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName'), addressType:addressType})
      else this.$mixpanel.track(`click-purchase-stap2`, {products: this.purchasingProduct.map(p=>{return p.id}),addressType:addressType})
      
      this.pageOpen[2] = true;
      this.pageNo = 2;
      this.pageLR = "r";
    },
    async submitPurchaseOrder2() {
      let addressType = this.indexAddress == 0 ? 'other' : this.indexAddress == 1 ? 'user' : 'apartment'
      if(this.user) this.$mixpanel.track(`click-purchase-stap3`, {products: this.purchasingProduct.map(p=>{return p.id}) , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName'), addressType:addressType})
      else this.$mixpanel.track(`click-purchase-stap3`, {products: this.purchasingProduct.map(p=>{return p.id}) , addressType:addressType})
      
      try {
        const config = await this.Parse.Config.get();
        const privateParam = config.get("horganiceBankAccount");
        if (privateParam) {
          this.banks[0].no = privateParam.bankCode;
          this.banks[0].bankName = "ธนาคารกสิกรไทย";
          this.banks[0].bankAccount = privateParam.accountName;
          this.banks[0].bankAccountNo = privateParam.accountNumber;
        }
      } catch (error) {
        console.log(error);
      }
      this.pageOpen[3] = true;
      this.pageNo = 3;
      this.pageLR = "r";
    },
    async submitPurchaseOrder3() {
      let addressType = this.indexAddress == 0 ? 'other' : this.indexAddress == 1 ? 'user' : 'apartment'
      if(this.user) this.$mixpanel.track(`click-purchase-stap4`, {products: this.purchasingProduct.map(p=>{return p.id}) , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
      else this.$mixpanel.track(`click-purchase-stap4`, {products: this.purchasingProduct.map(p=>{return p.id})})

      await this.savePurchaseOrder();
      this.pageOpen[1] = false;
      this.pageOpen[2] = false;
      this.pageOpen[3] = false;
      this.pageOpen[4] = true;
      this.pageNo = 4;
      this.pageLR = "r";
      $("#modal-confirm").addClass("modal-confirm-hide");
      // this.getBalanceStore();
    },
    async savePurchaseOrder() {
      let addressType = this.indexAddress == 0 ? 'other' : this.indexAddress == 1 ? 'user' : 'apartment'
      if(this.user) this.$mixpanel.track(`click-save-order`, {products: this.purchasingProduct.map(p=>{return p.id}) , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName'), addressType:addressType})
      else this.$mixpanel.track(`click-save-order`, {products: this.purchasingProduct.map(p=>{return p.id}), addressType:addressType})
      
      try {
        if (!this.isSavingPurchaseOrder) {
          this.isSavingPurchaseOrder = true;
          this.lastPurchase = await this.Parse.Cloud.run(
            "MarketProduct_savePurchaseOrder", {
              data : this.formPurchase,
              products : this.purchasingProduct
            }
          );
          this.$gtag.purchase({
            purchase_id: "P_" + this.lastPurchase.id,
            items: this.lastPurchase.get("sets"),
            value: this.lastPurchase.get("cost")
          })
          
          if (this.lastPurchase) {
            if(this.user) this.$mixpanel.track(`click-purchase-stap5`, {products: this.purchasingProduct.map(p=>{return p.id}) , isCancel : this.lastPurchase.get('isCancel') , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName') , addressType:addressType})
            else this.$mixpanel.track(`click-purchase-stap5`, {products: this.purchasingProduct.map(p=>{return p.id}) , isCancel : this.lastPurchase.get('isCancel')})
            
            this.lastPurchase.lastQuery = this.$moment();
            store.commit('setCarts', [])
            store.commit('setPurchasingProduct', [])
            localStorage.removeItem('carts');
          }
          this.isSavingPurchaseOrder = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async processImageProof(event) {
      if(this.user) this.$mixpanel.track(`click-add-proof`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName') , apartmentId: this.$route.query.apartmentId, clickEvent: this.formPurchase.proofOfPayment ? 'change' : 'add'})
      else this.$mixpanel.track(`click-add-proof` , {clickEvent: this.formPurchase.proofOfPayment ? 'change' : 'add'})

      if (event.target.files[0]) {
        this.isSavingImageProof = true;
        // console.log("in saving:", this.formPurchase.proofOfPayment);
        let image = event.target.files[0];
        try {
          let file64 = await this.getBase64(image);
          if (file64) {
            let parseFile = new this.Parse.File(
              "imageProofOfPayment.jpg",
              { base64: file64 },
              image.type
            );
            let fileSave = await parseFile.save();
            if (fileSave) this.formPurchase.proofOfPayment = fileSave;
            this.isSavingImageProof = false;
            // this.$refs.formPurchaseOrder.reset(); // if you need to re-use field or drop the same files multiple times
            // console.log("fin:", this.formPurchase.proofOfPayment);
          }
        } catch (error) {
          console.log(error);
          this.isSavingImageProof = false;
        }
      } else {
        // alert("file not found");
      }
    },
    changeSame: function() {
      if (this.formPurchase && this.formPurchase.userName) {
        if (this.formPurchase.isSameAddress && this.formPurchase.apartmentAddress) {
          this.formPurchase.apartmentAddressTax = this.formPurchase.apartmentAddress;
        }
        if (this.formPurchase.isSameName && this.formPurchase.userName) {
          this.formPurchase.userNameTax = this.formPurchase.userName;
        }
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    requestPurchase() {
      $("#modal-confirm").removeClass("modal-confirm-hide");
    },
    dateFormat(date, dateFormat) {
      if (date) {
        return this.$moment(date).format(dateFormat);
      } else {
        return "";
      }
    },
    closeConfirmModal(){
      $("#modal-confirm").addClass("modal-confirm-hide");
    },
    goToHomePage(){
      if(this.user) this.$mixpanel.track(`click-cart-select-more`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
      else this.$mixpanel.track(`click-cart-select-more`)
      this.closePurchaseModal()
      this.$router.push({ name: 'home'})
    },
    removeItem(index){
      this.purchasingProduct.splice(index, 1);
      store.commit('setPurchasingProduct', this.purchasingProduct)
      store.commit('setCarts', this.purchasingProduct.map(r => {return {productId : r.id , number: r.number}}))
      localStorage.setItem('carts', JSON.stringify(this.purchasingProduct.map(r => {return {productId : r.id , number: r.number}})));
    },
    async checkPromocode(){
      this.isInvalidPromoCode = false
      this.promoCode = await this.Parse.Cloud.run("MarketProduct_getPromoCode", {code:this.inputPromoCode}).catch(e => {})
      if(this.promoCode) this.formPurchase.promoCode = {
        mainProductId: this.purchasingProduct.map(r => {return r.id}),
        promoCodeId: this.promoCode.id,
        name: this.promoCode.get('name'),
        description: this.promoCode.get('description'),
        discountBath: 0,
        total: 0,
        type: "promocode",
        number: 1
        // minPrice: this.promoCode.get('minPrice')
      }
      else this.isInvalidPromoCode = true
      this.changeNumber()
    },
    removePromocode(){
      this.promoCode = ""
      this.formPurchase.promoCode = ""
      this.inputPromoCode = ""
      this.isInvalidPromoCode = false
      this.changeNumber()
    }
  },
  computed: {
    checkFormPurchase() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.number) {
          res += "<div>*จำนวนสั่งซื้อต้องมากกว่า 0</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    checkAddress() {
      if (this.formPurchase) {
        if (
          this.formPurchase.userName &&
          (this.formPurchase.userTel && (/^\d{10}$/).test(this.formPurchase.userTel)) &&
          ((this.formPurchase.apartmentId && this.formPurchase.apartmentName) || !this.formPurchase.apartmentId) &&
          this.formPurchase.apartmentAddress &&
          this.formPurchase.vatPer &&
          this.formPurchase.number &&
          this.formPurchase.number > 0
        ) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    checkFormAddress() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.userName) {
          res += "<div>*ไม่มีข้อมูลชื่อผู้สั่งซื้อ</div>";
        }
        if (!this.formPurchase.userTel) {
          res += "<div>*ไม่มีข้อมูลเบอร์โทรผู้สั่งซื้อ</div>";
        }
        if (this.formPurchase.userTel && !(/^\d{10}$/).test(this.formPurchase.userTel)) {
          res += "<div>*เบอร์โทรผู้สั่งซื้อไม่ถูกต้อง</div>";
        }
        if (!this.formPurchase.apartmentName && this.apartmentId) {
          res += "<div>*ไม่มีข้อมูลชื่อหอพัก</div>";
        }
        if (!this.formPurchase.apartmentAddress) {
          res += "<div>*ไม่มีข้อมูลที่อยู่จัดส่ง</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    checkFormProof() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.userNameTax) {
          res += "<div>*ไม่มีข้อมูล ชื่อผู้สั่งซื้อ/ชื่อบริษัท</div>";
        }
        if (!this.formPurchase.taxId) {
          res +=
            "<div>*ไม่มีข้อมูล เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี</div>";
        }
        if (!this.formPurchase.apartmentAddressTax) {
          res += "<div>*ไม่มีข้อมูล ที่อยู่ในการออกใบกำกับภาษี</div>";
        }
        if (!this.formPurchase.proofOfPayment) {
          res += "<div>*กรุณาแนบหลักฐานการโอน</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    getImage() {
      if (this.banks && this.banks[0] && this.banks[0].no)
        return require(`../assets/banks/${this.banks[0].no}.jpg`);
      else return null;
    },
    ...mapState([
      'purchasingProduct',
      'user',
      'apartment',
      'fromBuyNow',
      'carts',
      'owners'
    ])
  },
  watch: {
    inputRegister(dataChange) {
      if (
        dataChange &&
        dataChange.length == 10 &&
        this.registerData &&
        this.registerData.srError &&
        this.registerData.srError == dataChange
      ) {
        $("#input-register").addClass("input-repeat-error");
        $("#btn-register").addClass("btn-repeat-error");
      } else {
        $("#input-register").removeClass("input-repeat-error");
        $("#btn-register").removeClass("btn-repeat-error");
      }
    },
    isModalPurchase(isTrue) {
      if (isTrue) {
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-purchase").removeClass("modal-purchase-hide");
      } else {
        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-purchase").addClass("modal-purchase-hide");
      }
    },
    isModalRegister(isTrue) {
      if (isTrue) {
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-register").removeClass("modal-register-hide");
      } else {
        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-register").addClass("modal-register-hide");
      }
    },
    isModalConfirm(isTrue) {
      if (isTrue) {
        $("#modal-confirm").removeClass("modal-confirm-hide");

        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-purchase").addClass("modal-purchase-hide");
      } else {
        $("#modal-confirm").addClass("modal-confirm-hide");

        $("#main-cid-detail").addClass("modal-open");
        $("#modal-purchase").removeClass("modal-purchase-hide");
      }
    },
    purchasingProduct(newVal){
      this.changeNumber()
    },
    purchaseStap(newVal){
      if(newVal = 2){
        this.submitPurchaseOrder1()
      }
    },
    fromBuyNow(newVal) {
      if (newVal) {
        this.submitPurchaseOrder1()
      } else {
        this.pageOpen = {
          1: true,
          2: false,
          3: false,
          4: false
        }
        this.pageNo = 1
        this.changeNumber()
      }
    }
  }
}
</script>
<style lang="scss" scope>
$container-in-height: 370px;
$image-min: 240px;
$bg-color: #e9773b;
$color-text-black: rgb(71, 71, 71);
$color-text-black-light: rgba(71, 71, 71, 0.671);
$color-text-next: rgb(224, 134, 85);
$color-text-hide: rgb(170, 170, 170);
$color-text-success: rgb(66, 204, 2);
$color-text-next: rgb(0, 199, 10);
$color-text-fail: rgb(255, 0, 0);
$transition-time: 300ms;
$border-color-default: 1px solid rgba(148, 148, 148, 0.5);
.modal-purchase,
.modal-register {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(63, 63, 63, 0.857);
  z-index: 16;
  transition: all $transition-time;

  .container-purchase,
  .container-register {
    position: absolute;
    top: calc(54%);
    border: $border-color-default;
    border-radius: 3px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    min-height: calc(100% - 45px);
    padding: 0;
    z-index: 2;

    .header-purchase,
    .header-register {
      position: relative;
      background: rgb(241, 241, 241);
      border-bottom: $border-color-default;
      height: 50px;
      width: 100%;

      .text {
        pointer-events: none;
        color: rgb(80, 80, 80);
        font-size: 20px;
        font-weight: bold;
        line-height: 50px;
        padding: 0 20px;
      }

      .box-close {
        cursor: pointer;
        position: absolute;
        border-radius: 50%;
        background: #a7a7a7;
        right: 10px;
        padding: 5px;
        top: 10px;
        width: 30px;
        height: 30px;

        i.close-modal {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
          color: #ffffff;
          outline: none;
          border: none;
          box-shadow: none;
        }
      }
    }

    .btn-home {
      margin: 15px 5px;
      padding: 5px 10px;
      background: white;
      color: $bg-color;
      border: 1px solid $bg-color;
      border-radius: 3px;
      transition: all $transition-time;
      font-weight: bold;
      width: 40%;
    }
    .btn-home.non-active {
      pointer-events: none;
      cursor: default;
      color: $color-text-hide;
      border: 2px solid $color-text-hide;
    }
    .btn-home:hover {
      background: $bg-color;
      color: white;
    }
    .btn-home:focus {
      outline: unset;
    }

    .paging {
      position: relative;
      width: 100%;
      text-align: center;
      box-shadow: 0px 5px 5px rgb(231, 231, 231);
      .paging-page {
        border: $border-color-default;
        cursor: pointer;
        background: #ffffff;
        position: relative;
        display: inline-block;
        padding: 5px 5px;
        margin: 5px;
        margin-bottom: 5px;
        border-radius: 3px;
        @media screen and (max-width: 420px) {
          margin: 2px;
          padding: 5px 2px;
          font-size: 14px;
        }
        @media screen and (max-width: 320px) {
          font-size: 12px;
        }
      }

      .x {
        cursor: default;
        color: $color-text-hide;
        pointer-events: none;
        border: none;
      }

      .active {
        border: 2px solid $bg-color;
      }
    }

    .panel {
      position: relative;
      overflow: hidden;
      // text-align: center;
      .border-shadow{
        position: relative;
        top: -40px;
        box-shadow: 0 -5px 5px gray;
        content: " ";
        border: none;
      }
      div.t {
        // position: absolute;
        max-height: calc(75vh + 80px);
        overflow: auto;
        @media screen and (max-height: 850px) {
          max-height: calc(75vh + 60px);
        }
        @media screen and (max-height: 700px) {
          max-height: calc(75vh + 40px);
        }
        @media screen and (max-height: 500px) {
          max-height: calc(75vh - 10px);
        }
        @media screen and (max-height: 400px) {
          max-height: calc(75vh - 20px);
        }
        // box-shadow: inset 0 -10px 10px -15px #000000;
        display: block;
        visibility: hidden;
        // transition: all 500ms;
        width: 0;
        text-align: center;

        .row {
          display: none;
        }
      }

      div.t1 {
        // background: gray;
        left: 0;
      }

      div.t2L {
        // background: green;
        left: 0;
      }

      div.t2R {
        // background: green;
        right: 0;
      }

      div.t3L {
        // background: green;
        left: 0;
      }

      div.t3R {
        // background: green;
        right: 0;
      }

      div.t4 {
        // background: orange;
        right: 0;
      }

      div.active {
        visibility: visible !important;
        width: 100%;
        display: block;

        .row {
          width: 100%;
          display: inline-flex;
        }
      }
      div.t.non-active{
        display: none;
      }
    }
    .box-border{
      border: $border-color-default;
      border-radius: 3px;
    }
    .address-selector{
      .box-border{
        margin-bottom: 10px;
        cursor: pointer;
        padding:15px;
      }
      .active{
        border: 3px solid #e9773b;
        padding: 13px;
      }
      p{
        margin: 0;
        padding: 0;
        color: rgb(80, 80, 80);
      }
      .topic-address{
        font-size: 20px;
        font-weight: bold;
      }
      .detail-address{
        font-size: 14px;
      }
      .circle-out {
        display: block;
        width: 25px;
        min-height: 25px;
        background-color: white;
        border: 3px solid #e9773b;
        border-radius: 50%;
        position: relative;
        margin-top: 2px;
        margin-bottom: 7px;
        margin: 12px 5px;
      }
      .circle-in {
        position: absolute;
        left: 2px;
        top: 2px;
        width: 15px;
        height: 15px;
        background-color: #e9773b;
        border-radius: 50%;
      }
    }
    

    .row {
      position: relative;
      // display: inline-flex;
      padding: 0;
      margin: 0;

      .col {
        overflow: auto;
        // max-height: 90vh;
        position: relative;
        padding: 15px;
        flex-basis: unset;

        .box-list-product {
          width: 100%;
          background-color: white;
          margin-bottom: 20px;
          padding: 10px;
          border: $border-color-default;
          border-radius: 3px;
          .remove-item{
            display: block;
            width: 40px;
            margin: 0 auto;
            @media only screen and (max-width: 576px) {
              display: inline-block;
              margin-left: 10px;
              width: 40px;
            }
          }

          .box-image {
            // display: inline-block;
            height: 100px;
            width: 100px;
            background: white;
            margin: auto;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .box-text {
            position: relative;
            float: left;
            // display: inline-block;
            padding: 10px 10px;
            text-align: center;

            .head {
              font-size: 18px;
              line-height: 20px;
              word-wrap: break-word;
              color: $color-text-black;
              width: 100%;
              // font-weight: bold;
            }

            .type {
              margin-top: 10px;
              color: $color-text-black-light;
              font-size: 14px;
              padding-left: 5px;
              // padding-top: 5px;
            }

            .promotion {
              position: relative;
              margin-top: 10px;
              // padding-top: 5px;
              height: 20px;

              img {
                height: 100%;
                width: auto;
                object-fit: contain;
              }
            }
          }

          .box-price {
            vertical-align: middle;
            margin-top: 10px;
            .span-price {
              color: $color-text-black;
              font-size: 12px;

              span {
                text-decoration: line-through;
                font-size: 15px;
                padding-left: 5px;
              }
            }

            .text-price {
              color: $bg-color;
              font-size: 20px;
              font-weight: bold;
            }

            .span-vat {
              // text-align: right;
              font-size: 12px;
              color: $color-text-hide;
            }
          }
          .box-number{
            margin-top: 10px;
            padding: 0;
          }
        }

        .box-conclusion {
          position: relative;
          background: #ffffff;
          padding: 10px;
          max-width: 800px;
          margin-bottom: 10px;
          margin: 0 auto;
          color: rgb(80, 80, 80);
          .head {
            font-size: 18px;
            font-weight: bold;
            width: 100%;
          }
          .btn-check-promocode {
            padding: 6.5px 10px;
            background: white;
            color: grey;
            border: 1.4px solid grey;
            transition: all .3s;
            font-weight: bold;
            width:100%;
            margin: 0 auto;
            // border-radius: 5px;
          }
          .btn-check-promocode:hover {
            background: grey;
            color: white;
          }
          .btn-check-promocode:focus {
            outline: unset;
          }

          table.address {
            tr {
              th {
                width: 100%;

                i {
                  color: $bg-color;
                  margin-right: 10px;
                }
              }

              td {
                text-align: left;
                width: 100%;

                i {
                  color: $bg-color;
                  margin-right: 10px;
                }
              }

              td.address {
                padding-left: 20px;
              }
            }
          }

          table {
            width: 100%;
            font-size: 15px;
            color: $color-text-black-light;

            tr {
              th {
                text-align: left;
                font-weight: normal;
              }

              th.sum {
                font-weight: bold;
              }

              td {
                text-align: right;
              }

              td.sum {
                font-size: 20px;
                font-weight: bold;
                color: $bg-color;
              }
            }
          }

          .btn-purchase-order {
            cursor: pointer;
            font-size: 18px;
            text-align: center;
            width: 100%;
            padding: 5px 10px;
            margin-top: 10px;
            border: 2px solid $color-text-next;
            background: $color-text-next;
            color: white;
            transition: all $transition-time;
            pointer-events: visible;
          }

          .btn-purchase-order:hover {
            background: $color-text-next;
            color: #ffffff;
          }

          .btn-purchase-order.non-active {
            pointer-events: none;
            cursor: default;
            color: $color-text-hide;
            border: 2px solid $color-text-hide;
            background-color: white;
          }

          .text-require {
            margin-top: 10px;
            color: red;
          }
        }

        .box-banks {
          width: 100%;
          text-align: center;
          margin: 10px 0;

          .box-bank {
            cursor: pointer;
            position: relative;
            background: #ffffff;
            width: 150px;
            display: inline-block;
            border: 1px solid gray;
            margin: 0 10px;
            padding: 10px;
            font-size: 15px;

            i {
              color: $bg-color;
              font-size: 25px;
            }
          }

          .box-bank.non-active {
            cursor: default;
            pointer-events: none;
            background: rgb(235, 235, 235);
            color: rgb(177, 177, 177);
            border: 1px solid rgb(197, 197, 197);

            i {
              color: rgb(209, 209, 209);
            }
          }
        }

        .box-list-bank {
          // border: 1px solid gray;
          text-align: left;
          padding: 15px;
          display: inline-flex;
          width: 100%;
          background: rgb(255, 255, 255);

          .image-bank {
            text-align: center;
            width: 100%;
            padding: 10px;
            img {
              width: 100px;
              height: auto;
              object-fit: contain;
              @media screen and (max-width: 575px) {
                width: 120px;
              }
            }
          }

          .text-bank {
            padding: 0;
            width: 100%;
            text-align: center;
            margin-bottom: 15px;
            .account-name {
              font-size: 20px;
              color: $bg-color;
            }

            .account-no {
              font-size: 25px;
              font-weight: bold;
              color: $bg-color;
            }
            .bank-name {
              font-size: 18px;
              color: $color-text-black-light;
            }
          }

          .cost {
            width: 100%;
            text-align: center;

            .text {
              font-size: 18px;
            }

            .number {
              color: $bg-color;
              font-size: 25px;
              font-weight: bold;
            }
          }
        }

        .btn {
          cursor: pointer;
          padding: 5px 10px;
          margin: 20px 0;
          font-size: 18px;
          color: $bg-color;
          border: 2px solid $bg-color;
          background: #ffffff;
          min-width: 120px;
          transition: all $transition-time;
        }

        .btn:hover {
          color: #ffffff;
          background: $bg-color;
        }

        .not-active {
          pointer-events: none;
          color: $color-text-hide;
          border: 2px solid $color-text-hide;
        }

        .box-image {
          position: relative;
          text-align: center;

          .box-image-proof {
            margin: 0;
            display: inline-block;
            border: 1px solid $color-text-hide;
            background: rgba(216, 216, 216, 0.397);
            width: 300px;
            min-height: 300px;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }

        .box-proof {
          text-align: center;
        }

        .box-success-purchase {
          font-size: 18px;
          padding: 0 10px;
          .icon {
            i {
              font-size: 50px;
            }

            i.success {
              color: $color-text-success;
            }

            i.wait {
              color: rgb(219, 205, 0);
            }

            i.reject {
              color: $color-text-fail;
            }
          }

          .head {
            font-size: 25px;
            color: $color-text-black;
          }

          .detail {
            color: $color-text-black-light;
          }

          .last-purchase {
            color: $color-text-black;
            margin-top: 20px;
            font-size: 25px;

            .head {
              font-size: 20px;
              font-weight: bold;
            }

            .order-list {
              padding: 20px;
              @media screen and (max-width: 768px) {
                padding: 20px 0;
              }
              table {
                margin: 0;

                tr {
                  th {
                    font-size: 15px;
                    font-weight: bold;
                    @media screen and (max-width: 400px) {
                      font-size: 12px;
                    }
                  }

                  td {
                    padding: 5px;
                    font-size: 15px;
                    font-weight: normal;
                    @media screen and (max-width: 400px) {
                      font-size: 12px;
                    }
                  }

                  td.number {
                    text-align: right;
                  }

                  td.sum {
                    font-size: 22px;
                    font-weight: bold;
                    color: $bg-color;
                    @media screen and (max-width: 400px) {
                      font-size: 14px;
                    }
                  }

                  td.sum-text {
                    text-align: right;
                    font-weight: bold;
                  }
                }
              }
            }

            .box-address {
              // margin-bottom: 20px;
              padding: 10px 20px;

              .head {
                font-size: 20px;
                font-weight: bold;
                // margin-bottom: 10px;
              }

              .detail {
                border: 1px solid rgb(202, 202, 202);
                padding: 10px;
                font-size: 18px;
              }
            }
          }

          span {
            cursor: pointer;
            font-size: 15px;
            margin-right: 10px;

            i {
              margin-right: 5px;
              font-size: 15px;
            }
          }

          span.refresh i {
            transition: all $transition-time;
            transform: scale(1);
          }

          span.refresh:hover i {
            transform: rotate(90deg);
            // font-size: 20px;
          }
        }

        .btn-back {
          cursor: pointer;
          display: inline-block;
          font-size: 25px;
          padding: 10px 20px;
          margin: 0 20px;
          border: 2px solid $color-text-hide;
          background: #ffffff;
          color: $color-text-hide;
          transition: all $transition-time;
          height: 60px;
          vertical-align: middle;
        }

        .btn-back.registed {
          margin: 20px 0;
          width: 50%;
        }

        .btn-back:hover {
          background: $color-text-hide;
          color: #ffffff;
        }

        .btn-purchase-back {
          height: 60px;
          font-size: 25px;
          padding: 10px 20px;
          margin: 0;
        }
      }

      .col-register {
        max-height: 90vh;
        // padding: 0;
      }
    }

    .row-bottom {
      // position: absolute;
      overflow: hidden;
      display: block;
      margin: 0;
      margin-top: 10px;
      padding: 0;
      left: 0;
      bottom: 0;
      border: 1px solid i;

      .col {
        padding-bottom: 0;
        overflow: hidden;
      }

      .head {
        font-size: 25px;
        font-weight: bold;
        color: $bg-color;
        overflow: hidden;
      }

      .box-form-in {
        position: relative;
        text-align: left;
        margin-bottom: 15px;

        .same-data {
          margin: 0;
          padding: 0;
          padding-top: 28px;
          width: 100%;
          p {
            display:inline;
            vertical-align:top;
            position: relative;
            top:5px;
            margin-right: 10px;
          }
          input {
            width: 30px;
          }
        }

        .box-input {
          display: inline-block;
          width: 100%;

          textarea {
            height: 40px;
          }
        }

        label {
          font-size: 15px;
          // font-weight: bold;
          margin: 0;
          color: $color-text-black;

          span {
            font-size: 18px;
            color: red;
            margin-left: 5px;
          }
        }

        input {
          font-weight: bold;
          border: 1px solid $color-text-black-light;
          height: 40px;
          width: 100%;
          padding: 3px 10px;
          color: $color-text-black;
          font-size: 20px;
        }

        input::placeholder,
        textarea::placeholder {
          color: rgb(199, 199, 199);
          font-weight: normal;
          font-size: 15px;
        }

        textarea {
          font-weight: bold;
          border: 1px solid $color-text-black-light;
          width: 100%;
          padding: 3px 10px;
          color: $color-text-black;
          font-size: 20px;
          height: 50px;
          resize: none;
        }

        textarea.note {
          height: 80px;
        }
      }

      .note-star {
        pointer-events: none;
        // position: absolute;
        color: $color-text-hide;
        font-size: 14px;

        // padding: 10px;
        // margin-left: 10px;
        // left: 0;
        // bottom: 0;
        span {
          font-size: 18px;
          color: red;
          margin: 0 10px;
        }
      }
    }
  }

  .container-purchase:hover .box-close,
  .container-confirm:hover .box-close,
  .container-register:hover .box-close {
    animation: none;
  }

  .modal-confirm {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    background: rgba(63, 63, 63, 0.857);
    z-index: 2;
    transition: all $transition-time;

    .container-confirm {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: white;
      min-height: 80vh;
      border: $border-color-default;
      border-radius: 3px;
      // width: 55%;
      padding: 0;
      z-index: 3;

      .header-confirm {
        position: relative;
        background: rgb(241, 241, 241);
        height: 50px;
        width: 100%;
        
        .text {
          pointer-events: none;
          color: rgb(80, 80, 80);
          font-size: 20px;
          font-weight: bold;
          line-height: 50px;
          padding: 0 20px;
        }

        .box-close {
          cursor: pointer;
          position: absolute;
          border-radius: 50%;
          background: #a7a7a7;
          right: 10px;
          padding: 5px;
          top: 10px;
          width: 30px;
          height: 30px;
          transition: all $transition-time;

          i.close-modal {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 20px;
            color: #ffffff;
            outline: none;
            border: none;
            box-shadow: none;
          }
        }

        .box-close:hover {
          // transform: scale(1.3);
          transform: rotate(90deg);
        }
      }

      .panel {
        text-align: center;
        padding: 20px 0px;
        overflow: auto;
        max-height: 80vh;
        background: white;
        @media screen and (max-width: 768px) {
          text-align: center;
        }
        @media screen and (max-height: 750px) {
          max-height: 60vh;
        }
        // @media screen and (max-height: 750px) {
        //   max-height: 0vh;
        // }
        .box-order {

          // margin-bottom: 20px;
          .head {
            font-size: 20px;
            font-weight: bold;
          }

          .order-list {
            padding: 20px;
            @media screen and (max-width: 768px) {
              padding: 20px 0;
            }
            table {
              margin: 0;
              
              tr {
                th {
                  font-size: 15px;
                  font-weight: bold;
                  @media screen and (max-width: 400px) {
                    font-size: 12px;
                  }
                }

                td {
                  padding: 5px;
                  font-size: 15px;
                  font-weight: normal;
                  @media screen and (max-width: 400px) {
                    font-size: 12px;
                  }
                }

                td.number {
                  text-align: right;
                }

                td.sum {
                  font-size: 22px;
                  font-weight: bold;
                  color: $bg-color;
                  @media screen and (max-width: 400px) {
                    font-size: 14px;
                  }
                }

                td.sum-text {
                  text-align: right;
                  font-weight: bold;
                }
              }
            }
          }

          .conclude {
            font-size: 20px;

            span {
              font-size: 25px;
              font-weight: bold;
              color: $bg-color;
            }
          }
        }

        .box-address {
          // margin-bottom: 20px;
          padding: 10px 20px;

          .head {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .detail {
            border: 1px solid rgb(202, 202, 202);
            padding: 20px;
            font-size: 18px;
          }
        }

        .box-confirm {
          // margin-bottom: 20px;
          padding: 20px;

          .text {
            color: red;
            font-weight: bold;
            font-size: 20px;
          }

          .confirm {
            width: 100%;
            text-align: center;
            padding: 10px 0;

            .btn-back {
              cursor: pointer;
              display: inline-block;
              font-size: 20px;
              width: 30%;
              padding: 5px 10px;
              margin-top: 10px;
              margin-right: 20px;
              border: 2px solid $color-text-hide;
              background: #ffffff;
              color: $color-text-hide;
              transition: all $transition-time;
            }

            .btn-back:hover {
              background: $color-text-hide;
              color: #ffffff;
            }

            .btn-purchase-order {
              cursor: pointer;
              display: inline-block;
              font-size: 20px;
              text-align: center;
              width: 30%;
              padding: 5px 10px;
              margin-top: 10px;
              border: 2px solid $color-text-next;
              background: #ffffff;
              color: $color-text-next;
              transition: all $transition-time;
              pointer-events: visible;
            }

            .btn-purchase-order:hover {
              background: $color-text-next;
              color: #ffffff;
            }

            .btn-purchase-order.non-active {
              pointer-events: none;
              cursor: default;
              color: $color-text-hide;
              border: 2px solid $color-text-hide;
            }
          }
        }
      }
    }
  }
}

.modal-purchase:hover .box-close,
.modal-register:hover .box-close {
  animation: run-scal 1s infinite;
}

.modal-purchase-hide,
.modal-confirm-hide,
.modal-register-hide {
  // display:;
  left: -200vw !important;
}
@media only screen and (max-width: 540px) {
  .bb{
    padding: 100px;
    img{
      width: 100px;
    }
  }
}
</style>